module.exports = __webpack_public_path__ + "static/media/team2.ac398179.png";